import { render, staticRenderFns } from "./InboundShipment.vue?vue&type=template&id=085d389c"
import script from "./InboundShipment.vue?vue&type=script&lang=js"
export * from "./InboundShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports